import './CaseAlertDashboard.scss';

import { Alert, CardGroup } from '@ver-uds/uswds-react';
import React, { FC, useEffect, useState } from 'react';
import { faBellOn, faHourglassEnd, faRepeat, faTimesCircle } from '@fortawesome/pro-light-svg-icons';

import { useLogout } from '@vis-auth/react';
import CaseAlertCard from './CaseAlertCard/CaseAlertCard';
import { CaseAlerts } from '../../../models/CaseAlerts';
import useEveAuthService from '../../../services/EveAuthService';
import useV30Service from '../../../services/V30Service';

const CaseAlertDashboard: FC = () => {
  const [caseAlerts, setCaseAlerts] = useState<CaseAlerts>();
  const [error, setError] = useState<boolean>(false);

  const v30Service = useV30Service();
  const eveAuthService = useEveAuthService();
  const logout = useLogout();

  useEffect(() => {
    // Setting up case alerts
    const fetchCasesAlerts = (): void => {
      v30Service
        .getCasesAlerts()
        .then(async (response) => {
          if (response.status === 401) {
            // Commented out until 401 issue is resolved.
            // logout();
          } else {
            const data = await response.json();
            setCaseAlerts(data);
          }
        })
        .catch(() => {
          setError(true);
        });
    };

    if (!caseAlerts && eveAuthService.authorizeCasesPaths()) {
      fetchCasesAlerts();
    }
  }, [v30Service, eveAuthService, logout, caseAlerts]);

  return (
    <>
      {error && (
        <Alert className="alert-error margin-top-2" status="error" slim>
          <Alert.Text>Unable to retrieve data at this time. Refresh to try again.</Alert.Text>
        </Alert>
      )}

      <CardGroup className="margin-top-2">
        <CaseAlertCard
          svg={faTimesCircle}
          count={caseAlerts ? caseAlerts.cases_to_be_closed : undefined}
          title="Cases to be Closed"
          buttonText="View Cases to be Closed"
          searchFilter="cases_to_be_closed"
          errorOccurred={error}
        />
        <CaseAlertCard
          svg={faBellOn}
          count={caseAlerts ? caseAlerts.cases_with_new_updates : undefined}
          title="Cases with Updates"
          buttonText="View Updated Cases"
          searchFilter="cases_with_new_updates"
          errorOccurred={error}
        />
        <CaseAlertCard
          svg={faHourglassEnd}
          count={caseAlerts ? caseAlerts.work_docs_expiring : undefined}
          title="Cases with Expiring Authorization Docs"
          buttonText="View Expiring Doc Cases"
          searchFilter="work_docs_expiring"
          errorOccurred={error}
        />
        <CaseAlertCard
          svg={faRepeat}
          count={caseAlerts ? caseAlerts.recently_auto_closed : undefined}
          title="Recently Auto-Closed Cases"
          buttonText="View Auto-Closed Cases"
          searchFilter="recently_auto_closed"
          errorOccurred={error}
        />
      </CardGroup>
    </>
  );
};

export default CaseAlertDashboard;
